import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { FwButtonModule, FwIconButtonModule } from '@flywheel-io/vision';

import { MaterialModule } from '../material.module';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { ViewerFrameComponent } from './frame/viewer-frame.component';
import { ViewerFrameDialog } from './frame/viewer-frame-dialog.component';
import { MarkdownService } from './markdown.service';
import { OhifViewerDialog } from './ohifviewer/ohifviewer-dialog.component';
import { PDFViewerDialog } from './pdf-viewer/pdf-viewer-dialog.component';
import { TextViewerDialog } from './text-viewer/text-viewer-dialog.component';
import { VideoViewerDialog } from './video-viewer/video-viewer-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    MatDialogModule,
    PipesModule,
    FwButtonModule,
    FwIconButtonModule,
    SharedModule,
    VideoViewerDialog,
  ],
  declarations: [OhifViewerDialog, PDFViewerDialog, TextViewerDialog, ViewerFrameComponent, ViewerFrameDialog],
  exports: [VideoViewerDialog],
  providers: [MarkdownService],
})
export class ViewerModule {}
